// extracted by mini-css-extract-plugin
export default {"SpecialOffer":"SpecialOffer_SpecialOffer__omIuu"};